import {Component, OnInit} from "@angular/core";
import {MainService} from "src/app/Services/service.service";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {switchMap} from "rxjs/operators";

@Component({
  selector: "app-validate-email",
  templateUrl: "./validate-email.component.html",
  styleUrls: ["./validate-email.component.css"]
})
export class ValidateEmailComponent implements OnInit {
  constructor(private route: ActivatedRoute, public service: MainService) {
  }

  ngOnInit() {
    var code = this.route.snapshot.paramMap.get("code");
    if (code && code != "") {
      this.service.userService
        .validateEmail(code, "")
        .then(r => {
          this.service.Over18Years = true;
          const userDataObject = btoa(JSON.stringify({userId: r.userId.toString(), userPhone: r.userPhone}));
          this.service.route.navigate(["/validate-phone/" + userDataObject]);
        })
        .catch(e => {
          this.service.showError(e);
          this.service.route.navigate(["/"]);
        });
    }
  }
}
